export default __webpack_public_path__ + "static/media/penghua.7618c432.png";